var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"StepAdd"},[_c('Route',{staticClass:"Btn info",attrs:{"to":"AdminStepAdd"}},[_c('Icon',{attrs:{"name":"plus"}}),_vm._v(" Pridėti ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }